import React from "react";
import PropTypes from "prop-types";
import { X } from "lucide-react";

const Modal = ({ title, onClose, children, minHeight }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
    <div
      className={`relative flex flex-col w-full max-w-xl max-h-[90vh] mx-4 bg-white rounded-2xl shadow-2xl p-6 overflow-y-auto text-left ${
        onClose && !title ? "pr-10" : ""
      }`}
      style={minHeight ? { minHeight } : undefined}
    >
      {/* Title + close in one row when there is a title */}
      {title && (
        <div className="flex items-start justify-between gap-3 mb-6">
          <h2 className="font-SFPro font-bold text-xl text-gray-900 pr-2">{title}</h2>
          {onClose && (
            <button
              type="button"
              onClick={onClose}
              aria-label="Close"
              className="shrink-0 w-8 h-8 flex items-center justify-center rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors"
            >
              <X className="w-4 h-4" strokeWidth={2.25} />
            </button>
          )}
        </div>
      )}
      {/* No title: close sits in the corner — no extra flex row */}
      {onClose && !title && (
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          className="absolute top-4 right-4 z-10 w-8 h-8 flex items-center justify-center rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors"
        >
          <X className="w-4 h-4" strokeWidth={2.25} />
        </button>
      )}
      {children}
    </div>
  </div>
);

Modal.propTypes = {
  title: PropTypes.string,
  onClose: PropTypes.func,
  children: PropTypes.node.isRequired,
  minHeight: PropTypes.string,
};

export default Modal;
